module.exports = __webpack_public_path__ + "img/nohandle@2x.38d9eacb.png";